import React, {useContext, useEffect, useState} from 'react';
import Modal from "react-bootstrap/Modal";
import {
    FaBook,
    FaBookOpen,
    FaCoins,
    FaClock,
    FaSearch,
    FaMinusCircle,
    FaExclamationTriangle, FaTimes, FaCalendarAlt, FaFileArchive, FaFilter
} from "react-icons/fa";
import {Button, Col} from "react-bootstrap";
import {Context} from "../../../index";
import {
    check,
    updateUserVirtBalanceCancelAssignmentByOwnerApi
} from "../../../http/userAPI";
import {purchaseAssignmentAlwaysOnTop} from "../../../http/bookAPI";
import {toast} from "react-toastify";
import Row from "react-bootstrap/Row";
import {FaRegEye} from "react-icons/fa6";

const InfoAssUnderBookS1 = ({
    show,
    handleClose,
    assignment,
    updateAssignments,
    isBookOnTopActive = false,
    bookOnTopLabel = "Book on top",
    isPausedBySiblingOnTop = false,
    activeAssignmentOnTopId = null,
}) => {
const  { user } = useContext(Context);
    const [loading, setLoading] = useState(false);
    const [alwaysOnTopLoading, setAlwaysOnTopLoading] = useState(false);
    const [alwaysOnTopDays, setAlwaysOnTopDays] = useState(1);
    const [alwaysOnTopUntilOverride, setAlwaysOnTopUntilOverride] = useState(null);
    const [error, setError] = useState("");

    const alwaysOnTopPrices = {
        1: 0.50,
        2: 1.00,
        5: 2.00,
        7: 3.00,
    };

    const date = new Date(assignment.start_rev_date * 60 * 1000);

    // минуты -> миллисекунды (безопасно)
    const minutesToMs = (m) => (Number.isFinite(m) ? m * 60 * 1000 : NaN);

    // 1) Длинная дата + короткое время. По умолчанию en-GB (24h).
// Для AM/PM можно вызвать с { locale: 'en-US' }.
    const formatDateLongFromMinutes = (
        minutes,
        {
            locale = 'en-GB',
            timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
        } = {}
    ) => {
        const ms = minutesToMs(minutes);
        if (!Number.isFinite(ms)) return 'N/A';
        const d = new Date(ms);
        try {
            return new Intl.DateTimeFormat(locale, {
                dateStyle: 'long',  // e.g. "12 June 2025"
                timeStyle: 'short', // e.g. "22:15"
                timeZone,
            }).format(d);
        } catch {
            return d.toLocaleString(locale, { timeZone });
        }
    };

// 2) Длительность между двумя моментами (в минутах) => "Xd, YH, ZM"
    const formatDurationBetweenMinutes = (
        startMinutes,
        endMinutes = Math.floor(Date.now() / (60 * 1000))
    ) => {
        const s = minutesToMs(startMinutes);
        const e = minutesToMs(endMinutes);
        if (!Number.isFinite(s) || !Number.isFinite(e)) return 'N/A';

        const diffMs = Math.max(0, e - s);
        const totalMin = Math.floor(diffMs / (1000 * 60));
        const d = Math.floor(totalMin / (60 * 24));
        const h = Math.floor((totalMin % (60 * 24)) / 60);
        const m = totalMin % 60;
        return `${d}D, ${h}H, ${m}M`;
    };

// 3) Синоним: «сколько прошло с момента»
    const formatElapsedFromMinutes = (startMinutes) =>
        formatDurationBetweenMinutes(startMinutes);

    const formatDateTimeFromMs = (ms) => {
        const value = Number(ms);
        if (!Number.isFinite(value) || value <= 0) return "Not active";
        try {
            return new Intl.DateTimeFormat("en-GB", {
                dateStyle: "medium",
                timeStyle: "short",
            }).format(new Date(value));
        } catch {
            return new Date(value).toLocaleString();
        }
    };

    useEffect(() => {
        setAlwaysOnTopUntilOverride(null);
        setError("");
    }, [assignment?.id]);

    const alwaysOnTopUntilValue = alwaysOnTopUntilOverride ?? assignment?.always_on_top_until;
    const alwaysOnTopUntilMs = Number(alwaysOnTopUntilValue || 0);
    const isAlwaysOnTopActive = Number.isFinite(alwaysOnTopUntilMs) && alwaysOnTopUntilMs > Date.now();
    const assignmentBook = assignment?.book || assignment?.Book || {};
    const bookAlwaysOnTopUntilMs = Number(
        assignmentBook?.always_on_top_until ||
        assignment?.book_always_on_top_until ||
        assignment?.bookAlwaysOnTopUntil ||
        0
    );
    const isBookAlwaysOnTopActive =
        Boolean(isBookOnTopActive) ||
        (Number.isFinite(bookAlwaysOnTopUntilMs) && bookAlwaysOnTopUntilMs > Date.now());
    const itemTitleLabel =
        bookOnTopLabel?.toLowerCase?.().includes("product") ||
        assignmentBook?.book_type === "product" || assignment?.book_type === "product"
            ? "Product"
            : "Book";
    const isSiblingAlwaysOnTopActive =
        Boolean(isPausedBySiblingOnTop) ||
        (
            activeAssignmentOnTopId &&
            Number(activeAssignmentOnTopId) !== Number(assignment?.id)
        );
    const isAlwaysOnTopPurchaseDisabled =
        alwaysOnTopLoading ||
        isBookAlwaysOnTopActive ||
        isSiblingAlwaysOnTopActive;
    const isOpenAssignment =
        assignment?.assignment_status === "NEW" &&
        assignment?.reviewer_reading_step === "NO_STEP";
    const publisherMessage = String(assignment?.message_to_publisher || "");
    const isThreeDayUnclaimedLog =
        /3\s*days/i.test(publisherMessage) &&
        /(claimed|picked|pick|participant)/i.test(publisherMessage);

    // ✅ Полные названия месяцев
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    // ✅ Вычисляем, сколько времени прошло с момента начала чтения
    const now = new Date();
    const elapsedTime = now - date;
    const elapsedMinutes = Math.floor(elapsedTime / (1000 * 60));
    const elapsedHours = Math.floor(elapsedMinutes / 60);
    const elapsedDays = Math.floor(elapsedHours / 24);

    const remainingHours = elapsedHours % 24;
    const remainingMinutes = elapsedMinutes % 60;

    const threeLineToast = (title, message, newBalance) => {
        toast.success(
            <div >
                <div style={{ fontSize: '14px', fontWeight: 'bold', lineHeight: '1.4' }}>{title}</div>
                <div style={{ fontSize: '12px', lineHeight: '1.2', marginTop: '4px' }}>{message}</div>
                <div style={{ fontSize: '12px', lineHeight: '1.2', marginTop: '4px' }}>{newBalance}</div>
            </div>,
            { position: "top-center", autoClose: 8000 }
        );
    };


    const  handleCancelAssignment = async () => {

          setLoading(true);
            try {

            const updateUserData = await updateUserVirtBalanceCancelAssignmentByOwnerApi(user?.user?.id, assignment?.id)
            threeLineToast(updateUserData.title, updateUserData.message, updateUserData.newBalance);
                // 📌 Обновляем баланс в MobX store
            const data = await check();
            user.setUser(data);
            handleClose(); // Закрываем модальное окно
            updateAssignments(); // 🔥 Обновляем список заданий в BookFull

            } catch (error) {
                const errorMessage = error.response?.data?.message || "An error occurred while adding the assignment.";
                toast.error(`${errorMessage}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                setLoading(false);
            } finally {
                setLoading(false);
            }


    };

    const handlePurchaseAlwaysOnTop = async () => {
        if (isAlwaysOnTopPurchaseDisabled) return;
        setAlwaysOnTopLoading(true);
        setError("");
        try {
            const result = await purchaseAssignmentAlwaysOnTop(assignment?.id, alwaysOnTopDays);
            toast.success(result?.message || "Always on Top activated", {
                position: "top-center",
                autoClose: 5000,
            });
            if (result?.assignment?.always_on_top_until) {
                setAlwaysOnTopUntilOverride(result.assignment.always_on_top_until);
            }

            const data = await check();
            user.setUser(data);
            if (typeof updateAssignments === "function") {
                updateAssignments();
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "Failed to activate Always on Top";
            setError(errorMessage);
            toast.error(errorMessage, {
                position: "bottom-center",
                autoClose: 4000,
                hideProgressBar: false,
            });
        } finally {
            setAlwaysOnTopLoading(false);
        }
    };
    return (
        <Modal show={show}  onHide={() => { setError(""); handleClose(); }} top>
            <div className="modal-content">
                <div className="modal-header small" style={{height:40}}>
                    <h6 className="modal-title fs-6">Assignment: #{assignment?.bookId}-{assignment?.id}</h6>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => {
                            setError("");
                            handleClose();
                        }}
                    ></button>
                </div>

                <div className="modal-body small" style={{ lineHeight: "1.0" }}>
                    <p
                        className=" mb-2 fs-6 mt-0 text-muted" style={{ lineHeight: "1.0" }}

                    >
                        <FaSearch className="me-1 fa-shake " /> {/* ✅ Анимированная иконка */}
                        <strong className="m-0">Searching for a participant...</strong>
                    </p>



                    {/* Posted */}
                    {assignment?.start_rev_date && (
                        <p className="me-2 mb-1 mt-0 text-muted" style={{ lineHeight: "1.2" }}>
                            <FaBook className="me-2" />
                            Posted: <strong>{formatDateLongFromMinutes(assignment?.start_rev_date)}</strong>
                        </p>
                    )}

                    {assignment?.start_rev_date && (
                        <p className="me-2 mb-1 mt-0 text-muted" style={{ lineHeight: "1.2" }}>
                            <FaClock className="me-2  " />
                            Searching time:{" "}
                            <strong>
                                {formatElapsedFromMinutes(assignment?.start_rev_date)}
                            </strong>
                        </p>
                    )}

                    <p className="mb-1 mt-0 text-muted">
                        <FaBook className="me-2 mb-0 mt-0 text-muted" />
                        For:
                        <strong className=" m-1">
                            {(() => {
                                switch (assignment?.booksTypeId) {
                                    case 1: return "Book in Kindle,";
                                    case 2: return "Book in Paperback,";
                                    case 3: return "Book in Hardcover,";
                                    case 4: return "Audiobook,";
                                    case 5: return "Boost Existing Review,";
                                    case 6: return "Report Existing Review,";
                                    case 7: return "Physical Product,";
                                    case 8: return "Physical Product,";
                                    case 9: return "Physical Product,";
                                    case 10: return "Physical Product,";
                                    default:
                                        return "N/A";
                                }
                            })()}
                        </strong>
                    </p>

                    <p className="me-2 mb-1 mt-0 text-muted" style={{ lineHeight: "1.2" }}>
                        <FaBook className="me-2" />
                        Type:{" "}
                        <strong className="m-0">
                            {(() => {
                                switch (assignment.assTypeId) {
                                    case 1: return "Universal Assignment";
                                    case 2: return "Kindle Unlimited";
                                    case 3: return "Kindle Verified Purchase";
                                    case 4: return "Kindle Verified Purchase + Img";
                                    case 5: return "Kindle Verified Purchase Search&Buy";
                                    case 6: return "Kindle Verified Search&Buy + Img";
                                    case 7: return "Universal Assignment for Audio";
                                    case 8: return "Audible Promo Code Assignment";
                                    case 9: return "Verified Kindle Unlimited";
                                    case 10: return "Paperback BuyOut";
                                    case 11: return "Paperback Search&BuyOut";
                                    case 12: return "Paperback Verified Purchase + Img";
                                    case 13: return "Paperback Verified Purchase + Video";
                                    case 14: return "HC BuyOut";
                                    case 15: return "HC Search&BuyOut";
                                    case 16: return "HC Verified Pur. + Img";
                                    case 17: return "HC Verified + Video";
                                    case 18: return "PB Verified Purchase";
                                    case 19: return "PB Verified Purchase Search&Buy";
                                    case 20: return "HC Verified Purchase";
                                    case 21: return "HC Verified Purchase Search&Buy";
                                    case 22: return "Product BuyOut";
                                    case 23: return "Product Search&BuyOut";
                                    case 24: return "Product Verified Purchase";
                                    case 25: return "Product Verified + Img";
                                    case 26: return "Product Verified + Vid";
                                    case 27: return "Product VP Search&Buy";
                                    case 28: return "Make Helpful Internal";
                                    case 29: return "Write Report Internal";
                                    case 30: return "Make Helpful External";
                                    case 31: return "Write Report External";
                                    case 32: return "Set Stars Rating";
                                    default:
                                        return "Unknown Type"; // ✅ Защита от неверных значений
                                }
                            })()}
                        </strong>



                    </p>

                    <p className="me-2 mb-1 mt-0 text-muted" style={{ lineHeight: "1.2" }}>
                        <FaCoins className="me-2" />
                        Cost: <strong className="m-0">{assignment.assignment_price_publisher || "Unknown"}</strong> Virt /
                        <b className="text-danger">
                            {[10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27].includes(assignment?.assTypeId) ? (
                                assignment?.assignment_price_publisher
                                    ? ` $${assignment.book_cost_compensation}`
                                    : "N/A"
                            ) : (
                                (() => {
                                    let priceLabel;
                                    switch (assignment?.booksPriceId) {
                                        case 1: priceLabel = " Free"; break;
                                        case 2: priceLabel = " $0.99"; break;
                                        case 3: priceLabel = " $1.99"; break;
                                        case 4: priceLabel = " $2.99"; break;
                                        case 5: priceLabel = " $3.99"; break;
                                        case 6: priceLabel = " $4.99"; break;
                                        case 7: priceLabel = " $5.99"; break;
                                        case 8: priceLabel = " $6.99"; break;
                                        case 9: priceLabel = " $7.99"; break;
                                        case 10: priceLabel = " $8.99"; break;
                                        case 11: priceLabel = " $9.99"; break;
                                        default: priceLabel = " Unknown Type";
                                    }

                                    // Добавляем " Promo" при нужных условиях
                                    if (assignment?.booksPriceId === 1 && [3, 4, 5, 6, 32].includes(assignment?.assTypeId)) {
                                        priceLabel += " Promo";
                                    }

                                    return priceLabel;
                                })()
                            )}




                        </b>

                    </p>
                    {assignment.freePromoStatus && (
                        <>
                            <p className="me-2 mb-1 mt-0 text-muted" style={{ lineHeight: "1.2" }}>
                                <FaCalendarAlt className="me-2" />
                                Start:{" "}
                                <strong>
                                    {assignment?.free_promotion_start_date
                                        ? new Date(assignment.free_promotion_start_date).toLocaleDateString("en-GB", {
                                            day: "numeric",
                                            month: "short",
                                            year: "numeric",
                                        })
                                        : "—"}
                                </strong>{" "}
                                / Duration:{" "}
                                <strong>
                                    {(assignment?.free_promotion_duration ?? 0)}{" "}
                                    {(assignment?.free_promotion_duration ?? 0) === 1 ? "Day" : "Days"}
                                </strong>
                            </p>
                        </>
                    )}

                    <p className="me-2 mb-1 mt-0 text-muted" style={{ lineHeight: "1.2" }}>
                        <FaRegEye className="me-2" />
                        Views: <strong>{assignment?.views}</strong> / Clicks: <strong>{assignment?.clicks}</strong> / <strong>{elapsedDays}D {remainingHours}H</strong>
                    </p>
                    <p className="me-2 mb-1 mt-0 text-muted" style={{ lineHeight: "1.2" }}>
                        <FaFilter className="me-2" />
                         Country:
                        <b>
                            {(() => {
                                switch (assignment.assignment_prefer_country) {
                                    case "https://www.amazon.com":
                                        return " USA";
                                    case "https://www.amazon.ca":
                                        return " Canada";
                                    case "https://www.amazon.com.au":
                                        return " Australia";
                                    case "https://www.amazon.co.uk":
                                        return " United Kingdom";
                                    case "https://www.amazon.de":
                                        return " Deutschland";
                                    case "https://www.amazon.fr":
                                        return " France";
                                    case "https://www.amazon.it":
                                        return " Italia";
                                    case "https://www.amazon.es":
                                        return " España";
                                    case "https://www.amazon.in":
                                        return " India";
                                    case "https://www.amazon.co.jp":
                                        return " Japan";
                                    case "https://www.amazon.com.br":
                                        return " Brasil";
                                    case "https://www.amazon.nl":
                                        return " Netherlands";
                                    case "https://www.amazon.com.mx":
                                        return " Mexico";
                                    case "https://www.amazon.sg":
                                        return " Singapore";
                                    case "https://www.amazon.cn":
                                        return " China";
                                    default:
                                        return " All";
                                }
                            })()}</b>
                        {assignment?.rating_of_reviewer > 20 && (
                            <span className="ms-0 fw-semibold text-success">
                                        {" "}/ Quality: {assignment.rating_of_reviewer}%
                                     </span>
                        )}
                    </p>
                    {isOpenAssignment && (
                        <Row className="d-flex justify-content-center mt-4">
                            <Col md={10} className="border border-success border-opacity-50 p-3 rounded bg-white text-start shadow-sm">
                                <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
                                    <h6 className="mb-0 text-success">
                                        <FaCoins className="me-2" />
                                        Always on Top
                                    </h6>
                                    {isAlwaysOnTopActive && (
                                        <span className="badge text-bg-success">On top</span>
                                    )}
                                </div>

                                <p className="text-muted small mb-2" style={{ lineHeight: "1.35" }}>
                                    Until: <strong>{formatDateTimeFromMs(alwaysOnTopUntilValue)}</strong>.
                                    {" "}You can purchase more days while it is active; this simply moves the until date forward.
                                </p>

                                <div className="d-flex flex-wrap align-items-center gap-2">
                                    <select
                                        className="form-select form-select-sm"
                                        style={{ width: 150 }}
                                        value={alwaysOnTopDays}
                                        onChange={(e) => setAlwaysOnTopDays(Number(e.target.value))}
                                        disabled={isAlwaysOnTopPurchaseDisabled}
                                    >
                                        <option value={1}>1 day</option>
                                        <option value={2}>2 days</option>
                                        <option value={5}>5 days</option>
                                        <option value={7}>7 days</option>
                                    </select>

                                    <span className="small text-muted">
                                        Price: <strong>${alwaysOnTopPrices[alwaysOnTopDays].toFixed(2)}</strong>
                                    </span>

                                    <Button
                                        variant="success"
                                        size="sm"
                                        className="shadow-sm"
                                        onClick={handlePurchaseAlwaysOnTop}
                                        disabled={isAlwaysOnTopPurchaseDisabled}
                                    >
                                        {alwaysOnTopLoading
                                            ? "Processing..."
                                            : isAlwaysOnTopActive
                                                ? "Extend"
                                                : "Purchase"}
                                    </Button>
                                </div>

                                {isBookAlwaysOnTopActive && (
                                    <div className="alert alert-warning py-2 px-3 mt-2 mb-0" style={{ lineHeight: "1.35" }}>
                                        This {itemTitleLabel.toLowerCase()} already has {itemTitleLabel} Always on Top active.
                                        Assignment Always on Top is not available until it expires.
                                    </div>
                                )}

                                {!isBookAlwaysOnTopActive && isSiblingAlwaysOnTopActive && (
                                    <div className="alert alert-warning py-2 px-3 mt-2 mb-0" style={{ lineHeight: "1.35" }}>
                                        Another assignment for this {itemTitleLabel.toLowerCase()} already has Always on Top active.
                                        This assignment is paused in library/store rotation and cannot be promoted until the active on-top assignment is taken or expires.
                                    </div>
                                )}

                                {error && (
                                    <div className="small text-danger mt-2" style={{ lineHeight: "1.25" }}>
                                        {error}
                                    </div>
                                )}
                            </Col>
                        </Row>
                    )}
                    {assignment.message_to_publisher && (
                        <Row className="d-flex justify-content-center mt-3">
                            <Col md={10} className="text-muted small text-start">
                                <div className="border-top pt-2" style={{ lineHeight: "1.35" }}>
                                    {isThreeDayUnclaimedLog ? (
                                        <>
                                            <div>Log: assignment was not taken within 3 days.</div>
                                            <div>Views: <strong>{assignment?.views || 0}</strong>.</div>
                                            <div>
                                                Recommendation: improve the competitiveness of your offer or enable Always on Top.
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div>Log: assignment was taken and then canceled.</div>
                                            <div>
                                                Reason: <strong>{assignment.message_to_publisher || "No reason provided"}</strong>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    )}




                </div>

                <div
                    className="modal-footer small d-flex align-items-center justify-content-end gap-2 px-2"
                    style={{ height: 50, paddingTop: 0, paddingBottom: 0 }}
                >
                    <Button
                        variant="danger"
                        className="shadow-sm btn btn-sm d-flex align-items-center fw-light"
                        onClick={() => handleCancelAssignment()}
                        disabled={loading}
                    >
                        {loading ? "Saving..." : (<><FaMinusCircle className="me-2" /> Cancel Assignment</>)}
                    </Button>
                    <button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        onClick={() => {
                            setError("");
                            handleClose();
                        }}
                        disabled={loading}
                    >
                        Close
                    </button>
                </div>

            </div>
        </Modal>
    );
};


export default InfoAssUnderBookS1;
